// This should stay in sync with the enum in EE. We should verify that with integration tests.
// https://git.hubteam.com/HubSpotProtected/EligibilityEngine/blob/master/EligibilityEngineCore/src/main/java/com/hubspot/eligibilityengine/core/enums/PurchaseMotion.java
export const PurchaseMotions = {
  BUY_TOUCHLESS: 'buyTouchless',
  TALK_TO_SALES: 'talkToSales',
  TRIAL: 'trial',
  TALK_TO_SALES_FALLBACK: 'talkToSalesFallback',
  BUY_ADDITIONAL_CONTACTS: 'buyAdditionalContacts',
  BUY_ADDITIONAL_SEATS: 'buyAdditionalSeats',
  PRICING_PAGE_REDIRECT: 'pricingPageRedirect',
  REQUEST_ACCESS: 'requestAccess',
  REQUEST_SEAT: 'requestSeat',
  REQUEST_PRODUCT: 'requestProduct',
  ASSIGN_SEAT: 'assignSeat',
  VIEW_ACCOUNT: 'viewAccount'
};

// Utility type to check if a type is undefined or if all properties in a type are optional

/**
 * The type is a combination of:
 * - CommonPurchaseMotionProps (apiName, tracking, etc.)
 * - An object containing:
 *   - `purchaseMotion`: The purchase motion instance of type `T`.
 *   - `ctaProps` (optional): An object that may contain:
 *     - A mapping of purchase motion properties.
 *     - Potentially optional properties for the purchase motion.
 *
 * Additionally, if all of the props for the button are optional
 * (aka `IsUndefinedOrAllOptional<PurchaseMotionPropsMap[T]>` is true),
 * then `ctaProps` is optional.
 * Otherwise, `ctaProps` is required and must contain:
 * - A mapping of purchase motion properties.
 * - Potentially optional properties for the purchase motion.
 */